import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import CheckoutFormNew from "./CheckoutFormNew";
import { loadStripe } from "@stripe/stripe-js";
import axios from 'axios';
import tierHeader from "./tierHeader"
import { useDataManager } from "../backend/DataManager";

export const TestBasicMonthlyPriceID = "price_1PxsZO2KS8DEwxEg4djDSHVs"
export const TestBasicAnnualPriceID = "price_1Pzaaf2KS8DEwxEgnpvwDR5j"

export const BasicMonthlyPriceID = "price_1QXlli2KS8DEwxEg2RIBHaTG"
export const BasicAnnualPriceID = "price_1QklZb2KS8DEwxEg5ReoB1ac"

function Payment() {
  const [stripePromise, setStripePromise] = useState(null);

  const {priceIDToBuyMonth, setPriceIDToBuyMonth, priceIDToBuyAnnual, setPriceIDToBuyAnnual, productName, setProductName} = useDataManager();

  useEffect(() => {
    fetch("https://payment-pqnu.onrender.com/config").then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);

  const navigate = useNavigate();

  const handleExistingUserClick = () => {
    setPriceIDToBuyAnnual(BasicAnnualPriceID)
    setPriceIDToBuyMonth(BasicMonthlyPriceID)
    setProductName("Basic")
    navigate("/existingUser/login")
  }

  return (
    <>
    
  
    {tierHeader("Basic")}
      {stripePromise && (
        <Elements options={{ mode: 'setup', currency: 'gbp' }} stripe={stripePromise} >
          <CheckoutFormNew tier = {1} monthly={BasicMonthlyPriceID} annual ={BasicAnnualPriceID} founders = {false}/>
        </Elements>
      )}
      
    </>
    
  );
}

export default Payment;